// extracted by mini-css-extract-plugin
export default {"container":"ProductInfo_container__vvLCk","title":"ProductInfo_title__A0cOJ","item":"ProductInfo_item__TI1S9","info":"ProductInfo_info__p+vlK"};